// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import smoothscroll from 'smoothscroll-polyfill';
import '@/assets/js/jquery-3.4.1.min.js';
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFile } from '@fortawesome/free-regular-svg-icons'
import { faPlay, faMusic, faMountain, faHandPointRight, faPaperPlane, faCalendar, faPortrait, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faFontAwesome, faFacebookSquare, faInstagram, faTwitter, faAmazon, faApple, faGooglePlay} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueLazyload from 'vue-lazyload';
import Scrollspy from 'vue2-scrollspy';
import Vue2TouchEvents from 'vue2-touch-events';
import VueScrollTo from 'vue-scrollto';
import router from './router';
import store from './store/index';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {ApolloLink} from 'apollo-link';
import {InMemoryCache, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory';
import introspectionQueryResultData from './apollo/fragmentTypes.json';

import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

const httpLink = new HttpLink({
  // uri: 'https://dev-kgcvjm.pantheonsite.io/graphql',
  uri: 'https://backend.cvjm-laichingen.de/graphql',
});

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({});
  return forward(operation);
});

const link = middlewareLink.concat(httpLink);

const apolloClient = new ApolloClient({
  link: link,
  cache: new InMemoryCache({fragmentMatcher}),
  defaultHttpLink: false,
});

library.add(faFile)
library.add(faPlay, faMusic, faMountain, faHandPointRight, faPaperPlane, faCalendar, faPortrait, faAngleDown)
library.add(faFontAwesome, faFacebookSquare, faInstagram, faTwitter, faAmazon, faApple, faGooglePlay)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

Vue.use(VueApollo);
Vue.use(VueLazyload);
Vue.use(Scrollspy, {allowNoActive: true, offset: 73});
Vue.use(Vue2TouchEvents);
Vue.use(VueScrollTo, {
      container: "body",
      duration: 500,
      easing: "smooth",
      offset: 0,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true
});


// Disable VueWarn printing
Vue.config.warnHandler = function(msg, vm, trace) {

};

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  apolloProvider,
  router,
  components: { App },
  template: '<App/>'
})

smoothscroll.polyfill();
